export const STANDARD_SELLING_PRICE_EXPENSES = [
  { codeSnapshot: 'PRORATA', labelSnapshot: 'PRORATA', inputValue: 4 },
  { codeSnapshot: 'OUTILLAGE_COLLECTIF', labelSnapshot: 'Outillage collectif', inputValue: 1 },
  { codeSnapshot: 'MANUTENTION', labelSnapshot: 'Manutention', inputValue: 1 },
  { codeSnapshot: 'ETUDES_INTERNES', labelSnapshot: 'Études internes', inputValue: 3.5 },
  { codeSnapshot: 'ENCADREMENT', labelSnapshot: 'Encadrement', inputValue: 2.5 },
  { codeSnapshot: 'NEGOCIATION', labelSnapshot: 'Négociation', inputValue: 2 },
];

export const STANDARD_IMPUTED_CHARGES = [
  { codeSnapshot: 'CHARGE_MO', labelSnapshot: 'Charge imputée main-d’œuvre', calculationBase: 'labor_hours', inputValue: 5, unitLabel: '€/h' },
  { codeSnapshot: 'CHARGE_MATERIEL', labelSnapshot: 'Charge imputée matériel', calculationBase: 'material_cost', inputValue: 25, unitLabel: '%' },
  { codeSnapshot: 'CHARGE_SOUS_TRAITANCE', labelSnapshot: 'Charge imputée sous-traitance', calculationBase: 'subcontracting_cost', inputValue: 35, unitLabel: '%' },
  { codeSnapshot: 'CHARGE_COTRAITANCE', labelSnapshot: 'Charge imputée co-traitance', calculationBase: 'co_contracting_cost', inputValue: 0, unitLabel: '%' },
  { codeSnapshot: 'CHARGE_TACHE', labelSnapshot: 'Charge imputée travail à la tâche', calculationBase: 'other_cost', inputValue: 35, unitLabel: '%' },
];

const systemExpense = (item, categorySnapshot, calculationType, calculationBase) => ({
  ...item,
  _key: `system-${String(item.codeSnapshot).toLowerCase()}`,
  categorySnapshot,
  calculationType,
  calculationBase,
  amountMode: 'calculated',
  allocationMode: 'none',
  isClientVisible: false,
  allocations: [],
  enabled: true,
});

export const defaultQuoteExpenses = () => [
  ...STANDARD_IMPUTED_CHARGES.map((item) => systemExpense(item, 'imputed_charge', 'percentage', item.calculationBase)),
  ...STANDARD_SELLING_PRICE_EXPENSES.map((item) => systemExpense(item, 'selling_price_percentage', 'percentage', 'selling_price')),
];

const identity = (expense) => String(expense?.codeSnapshot || expense?.code_snapshot || expense?.labelSnapshot || expense?.label || '').trim().toUpperCase();

export const withRequiredQuoteExpenses = (expenses = []) => {
  const existing = Array.isArray(expenses) ? expenses : [];
  const byIdentity = new Set(existing.map(identity));
  const missing = defaultQuoteExpenses().filter((expense) => !byIdentity.has(identity(expense)));
  return [...existing, ...missing];
};

export const expenseFamily = (expense) => {
  const category = expense?.categorySnapshot || expense?.category_snapshot;
  if (category === 'imputed_charge') return 'imputed';
  if (category === 'selling_price_percentage') return 'selling';
  if ((expense?.calculationType || expense?.calculation_type) === 'percentage') {
    return (expense?.calculationBase || expense?.calculation_base) === 'selling_price' ? 'selling' : 'imputed';
  }
  return (expense?.allocationMode || expense?.allocation_mode) === 'none' ? 'direct' : 'allocated';
};
